export default "__VITE_ASSET__Du8nJTpc__"